module.exports = __webpack_public_path__ + "static/media/external-link-icon.49f46169.svg";